'use strict'

const isProd = process.env.NODE_ENV === 'production'

// 배포 환경별 변수 가져오기
const appEnv = isProd
  ? process.env.npm_config_appEnv || process.env.APP_ENV
  : process.env.APP_BRANCH || process.env.APP_ENV

let sentryProjectPrefix = ''

function getConfig() {
  const upperCaseAppEnv = appEnv ? appEnv.toUpperCase() : ''
  switch (upperCaseAppEnv) {
    case 'PROD':
      sentryProjectPrefix = 'prod'
      return require('./config.prod')
    case 'STG':
      sentryProjectPrefix = 'stg'
      return require('./config.stg')
    case 'QA':
      sentryProjectPrefix = 'qa'
      return require('./config.qa')
    case 'QA2':
      sentryProjectPrefix = 'qa2'
      return require('./config.qa2')
    case 'QA3':
      sentryProjectPrefix = 'qa3'
      return require('./config.qa3')
    case 'QA4':
      sentryProjectPrefix = 'qa4'
      return require('./config.qa4')
    case 'QA5':
      sentryProjectPrefix = 'qa5'
      return require('./config.qa5')
    case 'LOCAL':
      sentryProjectPrefix = 'local'
      return require('./config.local')
    default:
      sentryProjectPrefix = 'dev'
      return require('./config.dev')
  }
}

const _ref = getConfig()
const languages = ['ko']
const currencies = ['krw']
const currencySymbol = {
  krw: { default: '{0,0}원', en: 'KRW {0,0}' },
  usd: { default: '$ {0,0.00}', ko: 'USD {0,0.00}' },
  eur: { default: '€ {0,0.00}' },
  jpy: { default: '¥ {0,0.00}' },
  cny: { default: 'CNY {0,0.00}' },
  twd: { default: 'NT$ {0,0.00}' },
  hkd: { default: 'HK$ {0,0.00}' },
  sgd: { default: 'S$ {0,0.00}' },
  thb: { default: '฿ {0,0.00}' },
  aud: { default: 'AUD {0,0.00}' },
  chf: { default: 'SF {0,0.00}' },
  php: { default: '₱ {0,0.00}' },
  nzd: { default: '$ {0,0.00}' },
  inr: { default: '₹ {0,0.00}' },
  zar: { default: 'R {0,0.00}' },
  sek: { default: 'kr {0,0.00}' },
  nok: { default: 'kr {0,0.00}' },
  dkk: { default: 'k {0,0.00}' },
  rub: { default: '₽ {0,0.00}' },
  brl: { default: 'R$ {0,0.00}' },
  gbp: { default: '£ {0,0.00}' },
  myr: { default: 'RM {0,0.00}' },
  vnd: { default: '₫ {0,0.00}' },
  idr: { default: 'Rp {0,0.00}' },
  aed: { default: 'AED {0,0.00}' },
  cad: { default: '$ {0,0.00}' },
}

const initials = {
  locale: 'ko',
  fallbackLocale: 'ko',
  currency: 'krw',
  sentry: {
    org: 'hnt-it',
    release: 'fnd-user-pc-20250604',
    project: `${sentryProjectPrefix}-fnd-user-pc`,
  },
}

const api = {
  server: {
    dev: 'https://dev-msa-api.hanatour.com',
    local: 'https://dev-msa-api.hanatour.com',
    qa: 'https://qa-msa-api.hanatour.com',
    qa2: 'https://qa-msa-api.hanatour.com',
    qa3: 'https://qa-msa-api.hanatour.com',
    qa4: 'https://qa-msa-api.hanatour.com',
    qa5: 'https://qa-msa-api.hanatour.com',
    stg: 'https://fndapi.hanatour.com',
    prod: 'https://fndapi.hanatour.com',
  },
  seller: {
    dev: 'https://dev-seller.hanatour.com',
    qa: 'https://qa-seller.hanatour.com',
    qa2: 'https://qa-seller.hanatour.com',
    qa3: 'https://qa-seller.hanatour.com',
    qa4: 'https://qa-seller.hanatour.com',
    qa5: 'https://qa-seller.hanatour.com',
    stg: 'https://stg-seller.hanatour.com',
    prod: 'https://fndseller.hanatour.com',
    local: 'http://mohaji.hanatour.com:3100',
  },
}

// API 인증
const auth = {
  username: 'kr.mohaji.user',
  password: 'mohajiPlatform',
}

const {
  hosts,
  externalApi,
  deployEnv,
  axiosTimeout,
  gtxSellerIds,
  jtrSellerIds,
  grlSellerIds,
  rakutenGoraSellerIds,
  kkdaySellerIds,
} = _ref

module.exports = {
  languages,
  currencies,
  currencySymbol,
  initials,
  api,
  auth,
  hntDomain: 'hanatour.com',
  siteId: '00',
  hosts,
  externalApi,
  deployEnv,
  axiosTimeout,
  gtxSellerIds,
  jtrSellerIds,
  grlSellerIds,
  rakutenGoraSellerIds,
  kkdaySellerIds,
}
